const KEYNAME = {
  USERLIST : 'jaranda-userList',
  USER : 'jaranda-user'
}

export default KEYNAME;